import { type FetchOptions, FetchError } from "ofetch"
import { type RefreshTokenRequest, type RefreshTokenResponse } from "~/stores/user"
import { type ApiResponse } from "~/types/api"

export default (): FetchOptions => {
	const runtimeConfig = useRuntimeConfig()
	const userApiUrl = useUserApiUrl()
	const userStore = useUserStore()
	const app = useNuxtApp()
	const ntfy = useNtfy()

	const headers = useRequestHeaders()

	return {
		onRequest: (context) => {
			const token = userStore.token
			if (token) {
				context.options.headers = {
					...context.options.headers,
					// @ts-ignore
					Token: token,
					Authorization: token ? "Bearer " + token : undefined,
					Locale: app.$i18n.locale.value
				}
			}
			if (!(context.options.body instanceof FormData)) {
				context.options.headers = {
					...context.options.headers,
					// @ts-ignore
					"Content-Type": "application/json"
				}
			}
			if (process.server) {
				if (headers["x-real-ip"]) {
					// @ts-ignore
					context.options.headers["X-Real-IP"] = headers["x-real-ip"]
				}
				if (headers["x-forwarded-for"]) {
					// @ts-ignore
					context.options.headers["X-Forwarded-For"] = headers["x-forwarded-for"]
				}
			}
			context.options.baseURL = import.meta.server ? runtimeConfig.baseUrl : runtimeConfig.public.baseUrl
		},
		onResponse: async (context) => {
			if (context.response.ok) {
				const data = context.response?._data as ApiResponse
				userStore.time = data?.time
				userStore.elapsedTime = 0
				return
			}
			const refreshToken = userStore.refreshToken
			let token = userStore.token
			if (context.response.status == 401 && (refreshToken || token)) {
				if (refreshToken && token) {
					try {
						const r = await $fetch<RefreshTokenResponse>(userApiUrl.RefreshToken.url(), {
							baseURL: import.meta.server ? runtimeConfig.baseUrl : runtimeConfig.public.baseUrl,
							method: userApiUrl.RefreshToken.method,
							headers: {
								Token: token
							},
							body: {
								refresh_token: refreshToken
							} as RefreshTokenRequest
						})
						token = r.data.token
						userStore.setToken(token)
						userStore.setRefreshToken(refreshToken)
						ntfy.set(
							r.data.ntfy_topic || ntfy.ntfyTopic.value || null,
							r.data.ntfy_token || ntfy.ntfyToken.value || null
						)
					} catch (error: any) {
						if (error instanceof FetchError) {
							await userStore.logout(false)
						}
						error.response && (context.response = error.response)
						return
					}
				} else {
					await userStore.logout(false)
				}
				try {
					context.response = await $fetch.raw<any>(context.request, {
						...(context.options as any),
						headers: {
							...context.options.headers,
							Token: token
						}
					})
				} catch (error: any) {
					error.response && (context.response = error.response)
				}
			}
		}
	}
}
